enum PromotionGroupState {
    NewPromotionGroup = 'New',
    ActivePromotionGroup = 'Active',
}
export default PromotionGroupState;
